<script>
export default {
    name: 'TodayData',
    data() {
        return {
            panelList: [
                {
                    label: "接待会话数",
                    tip: "用户发起，有机器人参与的会话数",
                    dot: "-"
                },
                {
                    label: "会话转人工率",
                    tip: "用户发起，有机器人参与转人工会话数/接待会话数",
                    dot: "-"
                }
            ],
            tableData: [],
            page: 1,
            total: 1,
        }
    }
}

</script>

<template>
    <div class="today-data">
        <div class="panel-list">
            <div class="panel-one" v-for="(item, index) in panelList" :key="index">
                <div class="panel-title">
                    <span>{{item.label}}</span>
                    <el-tooltip effect="dark" placement="top" :content="item.tip">
                        &nbsp;<i style="color: #C4C4C4;" class="el-icon-question"></i></el-tooltip>
                </div>
                <div class="panel-dot">
                    {{item.dot}}
                </div>
            </div>
        </div>
        <div class="table-wrapper">
            <div class="table-header">
                <h3>热门问题知识</h3>
            </div>
            <div class="table-container">
                <el-table :data="tableData" height="364" header-cell-class-name="custom-header">
                    <el-table-column label="排名"></el-table-column>
                    <el-table-column label="问题"></el-table-column>
                    <el-table-column label="答案"></el-table-column>
                    <el-table-column label="咨询人数"></el-table-column>
                    <el-table-column label="转人工率"></el-table-column>
                    <template slot="empty">
                        <div class="no-data" style="display: flex;justify-content: center;align-items: center;flex-direction: column;padding: 50px 0;">
                            <img style="width: 150px;height: 150px;" :src="require('@/assets/images/training/scene/noResult.svg')" alt="">
                            <span>暂无数据</span>
                        </div>
                    </template>
                </el-table>
            </div>
            <div class="page">
                <el-pagination
                    background
                    layout="prev, pager, next, jumper"
                    :total="1">
                </el-pagination>
            </div>
        </div>

    </div>
</template>

<style scoped lang="scss">
.today-data {
    .table-wrapper {
        width: 100%;
        margin-top: 32px;
        .table-container {
            &:deep(.el-table) {
                .custom-header {
                    background: #f5f7fa;
                    color: #161823;
                }
            }
        }
        .page {
            padding-top: 24px;
            width: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }
        .table-header {
            h3 {
                margin-bottom: 32px;
                font-weight: 500;
                font-size: 16px;
                color: #161823;
            }
        }
    }
    &, & * {
        box-sizing: border-box;
    }
    width: 100%;
    .panel-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .panel-one {
        padding: 8px 16px;
        width: 216px;
        height: 95px;
        background-color: #fafafb;
        border-radius: 8px;
        margin-right: 16px;
        .panel-title {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: #16182357;
            span {
                margin-right: 6px;
            }
        }
        .panel-dot {
            margin-top: 16px;
            font-weight: 600;
            font-size: 36px;
            color: #161823;
        }
    }
}

</style>
